"use strict";

import axios from 'axios'
import Vue from 'vue'
import EventBus from './vue-event-bus'

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL

const token = $cookies.get('__fw_token')
if (token) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
} else {
  //console.log('no token')
}

let config = {
  // baseURL: process.env.VUE_APP_API_BASE_URL
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
}

const _axios = axios.create(config)

_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    return config
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

const ignore = ['https://api.feature.watch/login', 'https://api.feature.watch/user/notifications']

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    //console.log(response)
    // Do something with response data
    return response
  },
  function(error) {
    //console.log('error', error.response)
    // Do something with response error
    if (error.response.status === 401 && ignore.indexOf(error.response.request.responseURL) === -1) {
      EventBus.$emit('auth:showSignUp')
    } else if (error.response.status === 501 && ignore.indexOf(error.response.request.responseURL) === -1) {
      window.location.href = `${process.env.VUE_APP_BASE_APP_URL}/login`
    }

    return Promise.reject(error)
  }
)

Plugin.install = function (Vue, options) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    },
  });
};

Vue.use(Plugin)

export default Plugin;
